export const areaGeneralError = (logo, chat) => {
    return (
        <div p="area.GeneralError" hidden>
            <div class="alert-modal-wrapper">
                <div class="alert-modal-content">
                    <div p="generalErrorMsg"></div>
                    <button class="btn btn-primary" p="generalErrorBtn">OK</button>
                </div>
            </div>
        </div>
    )
}
